<template>
    <v-dialog v-model="dialog" persistent width="70%" scrollable>
        <v-btn color="primary" dark slot="activator" @click="onCreateClick()">
            <v-icon small>$vuetify.icons.rms_create</v-icon>
            {{ $t("program.event.link_events") }}
        </v-btn>
        <v-card>
            <v-card-title class="grey lighten-3">
                <h3>{{ $t("program.event.link_events") }}</h3>
                <div class="text-right">
                    <v-btn class="mx-0" small dark icon color="grey" @click.native="reset()">
                        <v-icon small>$vuetify.icons.rms_close</v-icon>
                    </v-btn>
                </div>
            </v-card-title>
            <v-card-text>
                <v-card-title >
                    <v-flex xs6 md8 lg8>
                        <h1 v-if="screeners && linkedScreenerIds.length" class="grey--text text--darken-3">{{$t('program.event.link.linking.status', {
                            linkedEvents: linkedScreenerIds.length,
                            totalEvents: screeners.total
                        })}}</h1>
                    </v-flex>
                    <v-flex xs12 md4 lg4 class="px-2 ">
                        <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Search"
                            outline
                            hide-details
                            @click:append="getScreeners()"
                            ></v-text-field>
                    </v-flex>
                </v-card-title>
                <v-data-table
                    :headers="tableHeaders"
                    :items="filteredScreeners"
                    v-bind:pagination.sync="pagination"
                    :rowsPerPageItems="[20, 50, 100]"
                    :total-items="screeners.total"
                >
                    <template v-slot:items="props">
                        <td class="text-xs-left subheading">{{ props.item.id }}</td>
                        <td class="pa-3">
                            <v-img
                                v-if="props.item.films[0].thumburls"
                                :src="props.item.films[0].thumburls"
                                contain
                            ></v-img>
                        </td>
                        <td class="text-xs-left">{{
                            props.item.title[$i18n.locale] ||
                            props.item.title.en ||
                            "Unknown Title"
                          }}</td>
                        <td class="text-xs-left">{{ fmtTime(props.item.screening_starts_at) }}</td>
                        <td class="text-xs-left">{{ fmtTime(props.item.screening_ends_at) }}</td>
                        <td>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" @click="linkScreener(props.item)" small icon >
                                        <v-icon color="success">mdi-link-plus</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ $t('program.page.events.link.dialog.link.btn.tooltip') }}</span>
                            </v-tooltip>

                        </td>
                    </template>
                </v-data-table>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <div class="caption error--text">{{ $t('program.event.link.linking.save.warning') }}</div>
                <v-spacer></v-spacer>
                <v-btn :disabled="!linkedScreenerIds.length" @click="linkToProgram()" small color="success">{{ $t('program.event.link.linking.save.btn') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import i18n from "@/i18n";
import DateTimePicker from "@/components/DateTimePicker";
import rules from '@/validation';
import { mapGetters } from 'vuex';
import { utcToTz } from "@/helper";
import momentTz from 'moment-timezone';


export default {
    name: 'EventLinkDialog',
    props: {
        program: {
            type: Object,
            default: null
        }
    },
    components: { DateTimePicker },
    data() {
        return {
            tableHeaders: [
                {
                    text: i18n.t("progrom.events.table.header.s.n"),
                    align: "left",
                    sortable: false,
                    value: "",
                },
                {
                    text: i18n.t("progrom.events.table.header.thumbnail"),
                    align: "left",
                    value: ""
                },
                {
                    text: i18n.t("progrom.events.table.header.title"),
                    align: "left",
                    value: ""
                },
                {
                    text: i18n.t("progrom.events.table.header.start_date"),
                    align: "left",
                    sortable: true,
                    value: "screening_starts_at",
                },

                {
                    text: i18n.t("progrom.events.table.header.end_date"),
                    align: "left",
                    sortable: true,
                    value: "screening_ends_at",
                },
                {
                    text: i18n.t("progrom.events.table.header.action"),
                    align: "left",
                    sortable: false,
                },
            ],
            ProgramEvent: [
                {
                    id: 1,
                    title: "abc",
                    type: "xyz",
                    start_date: "2022-01-01",
                    end_date: "2022-01-01",

                },
            ],
            rules,
            search: '',
            dialog: false,
            screeners: null,
            loading: false,
            pagination: {
                sortBy: "created_at",
                descending: true,
                page: 1,
                rowsPerPage: 20,
                perPage: 20,
                totalItems: 0,
            },
            linkedScreenerIds: []
        };
    },
    created() {
        this.getScreeners()
        this.setLinkedScreenerIds()
    },
    watch: {
        pagination: {
            handler(newData, oldData) {
                this.getScreeners()
            },
            deep: 'true'
        }
    },

    computed: {
        ...mapGetters('company', {
            timezone: 'getSelectedCompanyTimezone',
            company: 'getSelectedCompany'
        }),

        filteredScreeners() {
            if(!this.screeners || !this.screeners.data.length){
                return []
            }

            // Check if linkedScreenerIds is empty
            if (!this.linkedScreenerIds.length) {
                return this.screeners.data;
            }

            return this.screeners.data.filter(screener =>
                !this.linkedScreenerIds.includes(screener.id)
            );
        }
    },

    methods: {

        reset() {
            this.dialog = false;
        },

        async getScreeners() {
            await this.$store.dispatch('screener/list',{
                perPage: this.pagination.rowsPerPage,
                non_vod_event: true,
                search: this.search,
                page: this.pagination.page
            })
            .then((response) => {
                this.screeners = response.screeners
            })
            .catch((error) => {
                this.$store.dispatch("app/showMessage", {
                    message: error.message,
                    color: "error"
                });
            })
        },
        setLinkedScreenerIds() {
            if(!this.program || !this.program.screeners.length){
                return
            }

            this.linkedScreenerIds = this.program.screeners.map(screener => screener.id)
        },

        fmtTime(input) {
            if (input && this.company) {
                // OS local timezone
                var timezone = momentTz.tz.guess(true);
                return utcToTz(input, timezone, "MMMM Do YYYY, h:mm a");
            }
        },

        onCreateClick(){
            this.getScreeners()
        },
        linkScreener(screener) {
            if (!this.linkedScreenerIds.includes(screener.id)) {
                this.linkedScreenerIds.push(screener.id);
            }
        },
        linkToProgram() {
            if(!this.linkedScreenerIds.length){
                return
            }

            this.program.screener_ids = this.linkedScreenerIds
            this.$emit('update')
        },
    },
};
</script>
<style scoped>
.text-right {
    position: absolute;
    right: 2%;
}
</style>
